import glamorous from 'glamorous';

const MainContentWrapper = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 2,
  background: '#f8f8f8',
  justifyContent: props.isReady && !props.isFailure ? 'flex-start' : 'center',
  alignItems: props.isReady && !props.isFailure ? 'stretch' : 'center',
  padding: !props.isFailure ? 0 : 32,
}));

export default MainContentWrapper;



// WEBPACK FOOTER //
// ./src/components/layout/MainContentWrapper.js